import { render, staticRenderFns } from "./ShowSnapshotSkeleton.vue?vue&type=template&id=281bbb78&scoped=true&"
import script from "./ShowSnapshotSkeleton.vue?vue&type=script&lang=js&"
export * from "./ShowSnapshotSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ShowSnapshotSkeleton.vue?vue&type=style&index=0&id=281bbb78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281bbb78",
  null
  
)

export default component.exports